import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import rita from '../../../assets/comercial_imgs/rita.png';
import { NewYearAdmissionProps } from '../../../utils/interfaces';

import './SummerCamp.css';

const SummerCamp: React.FC<NewYearAdmissionProps> = ({}) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <section className="summercamp__general">
        <div className="summercamp__wrapper">
          <div className="summercamp__main_content">
            <div className="summercamp__yellow">
              <div className="summercamp__sun_icon">☀️</div>
              <div className="summercamp__admission_info">
                <h2 className="summercamp__title">Летние занятия шахматами</h2>
                <p className="summercamp__comercial_text">
                  Приглашаем всех желающих!
                </p>

                <ul className="summercamp__features">
                  <li className="summercamp__feature_item">
                    <span className="summercamp__feature_icon">♟️</span>
                    <span>Погружение в мир шахмат и улучшение навыков</span>
                  </li>
                  <li className="summercamp__feature_item">
                    <span className="summercamp__feature_icon">📆</span>
                    <span>Гибкий формат: весь месяц или одна-две недели</span>
                  </li>
                  <li className="summercamp__feature_item">
                    <span className="summercamp__feature_icon">💰</span>
                    <span>1 неделя — 4 500 ₽</span>
                  </li>
                </ul>

                <div className="summercamp__meta_row">
                  <div className="summercamp__meta_item">
                    <span className="summercamp__meta_icon">📅</span>
                    <span>1–26 июня 2026</span>
                  </div>
                  <div className="summercamp__meta_item">
                    <span className="summercamp__meta_icon">🕑</span>
                    <span>Понедельник - четверг</span>
                  </div>
                </div>

                <div className="summercamp__buttons_row">
                  <button
                    className="summercamp__button"
                    onClick={() => navigate('/schedule')}
                  >
                    Записаться &#8594;
                  </button>
                  <button
                    className="summercamp__results_button"
                    onClick={openModal}
                  >
                    <span className="summercamp__results_icon">📋</span>
                    Подробнее о занятиях
                  </button>
                </div>
              </div>
            </div>

            <img
              className="summercamp__photo"
              src={rita}
              alt="Ребёнок играет в шахматы"
            />
          </div>
        </div>
      </section>

      {isModalOpen && (
        <div
          className="summercamp__modal_overlay"
          role="button"
          tabIndex={0}
          onClick={closeModal}
          onKeyDown={(e) => e.key === 'Escape' && closeModal()}
          aria-label="Закрыть модальное окно"
        >
          <div
            className="summercamp__modal"
            role="button"
            tabIndex={0}
            onClick={closeModal}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                closeModal();
              }
            }}
          >
            <button
              className="summercamp__modal_close"
              onClick={closeModal}
              aria-label="Закрыть"
            >
              ✕
            </button>
            <h3 id="summercamp-modal-title" className="summercamp__modal_title">
              Летние занятия шахматами — подробнее
            </h3>
            <div className="summercamp__modal_body">
              <p>
                Приглашаем всех желающих на увлекательные летние занятия
                шахматами, которые будут проходить с 1 по 26 июня!
              </p>
              <p>
                Расписание занятий можно найти{' '}
                <button
                  className="summercamp__buttonlink"
                  onClick={() => navigate('/schedule')}
                >
                  здесь
                </button>
                .
              </p>
              <p>
                Это отличная возможность погрузиться в мир шахмат, улучшить свои
                навыки и встретить единомышленников! Мы предлагаем гибкий
                формат: вы можете заниматься весь месяц или выбрать одну или две
                недели.
              </p>
              <p>
                <strong>Стоимость:</strong> одна неделя — 4 500 рублей.
              </p>
              <p className="summercamp__modal_signature">
                Ждём вас на наших занятиях!
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SummerCamp;
